import React from "react"
import PropTypes from "prop-types"

import WhoCanContactMeContainer from './WhoCanContactMeContainer'
import MatchFiltersContainer from './MatchFiltersContainer'

class FilterContainer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      matches: [],
      tab: 0,
    }

    this.tabStyle = this.tabStyle.bind(this)
  }

  tabStyle(tab) {
    if(tab === this.state.tab) {
      return {
        color: "#01579B",
        borderBottom: '2px solid #03A9F4',
        cursor: 'pointer',
        padding: 10,
        width: '50%'
      }
    } else {
      return {
        color: "#A3A3A4",
        borderBottom: '2px solid #E9E9EB',
        cursor: 'pointer',
        padding: 10,
        width: '50%'
      }
    }
  }


  render() {
    return(
      <div className="filterContainer">
        <div style={{textAlign: 'right', padding: 10}}>
          <button
            onClick={() => this.props.getMatches()}
            className="small_button_primary">Done</button>
        </div>
        <div style={{display: 'flex', flexDirection: 'row', paddingTop: 20, justifyContent: 'space-evenly'}}>
          <h4 style={this.tabStyle(0)} onClick={() => this.setState({tab: 0})}>Filter my matches</h4>
          <h4 style={this.tabStyle(1)} onClick={() => this.setState({tab: 1})}>Who can contact me</h4>
        </div>

        {this.state.tab === 0 &&
          <MatchFiltersContainer
            current_user={this.props.current_user}
            languages_users={this.props.languages_users}
            premiumUser={this.props.premiumUser}
            toggleProModal={this.props.toggleProModal}
            filters={this.props.filters}
            updateFilter={this.props.updateFilter}
            getMatches={this.props.getMatches}
            learningLanguages={this.props.learningLanguages}
            nativeLanguages={this.props.nativeLanguages}
          />}
        {this.state.tab === 1 && <WhoCanContactMeContainer
            current_user={this.props.current_user}
            idVerification={this.props.idVerification}
            premiumUser={this.props.premiumUser}
            pro_settings={this.props.pro_settings}
            toggleProModal={this.props.toggleProModal}
            updateIdVerification={this.props.updateIdVerification}
            updateUserSettings={this.props.updateUserSettings}
          />}
      </div>
    )
  }
}


export default FilterContainer
